import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { EVENT_QUERY_KEYS } from '../../../constants/queryKeys';
import EventApi2 from '../../../lib/api/event/EventApiV2';
import { GetEventListRequestType } from '../../../types/query/event/list';
import { QueryOptions } from '../../../types/query/useQuery';
import { EventsFindResponseBodyDto } from '../../../types/api/events';

type UseEventListQueryArgsType<SelectResultType> = {
  payload: GetEventListRequestType;
  options?: QueryOptions<EventsFindResponseBodyDto, unknown, SelectResultType>;
};
export const useEventListQuery = <SelectResultType>({
  payload,
  options,
}: UseEventListQueryArgsType<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<EventsFindResponseBodyDto, unknown, SelectResultType>(
    [...EVENT_QUERY_KEYS.LIST, payload],
    async (): Promise<EventsFindResponseBodyDto> => {
      return await EventApi2.getEventList(payload);
    },
    {
      ...options,
    },
  );
};
